import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ModalDialogType, Personality, UserAndSellerShowMode } from 'src/app/@core/constants';
import { PosConfirmationService } from 'src/app/@core/services/pos-confirmation.service';
import { PosCreateCustomerModalService } from 'src/app/@core/services/pos-create-customer-modal.service';
import { PosUpdateRtnFiscalIdModalService } from 'src/app/@core/services/pos-update-rtn-fiscal-id-modal.service';
import { Loan } from 'src/app/models/loan';
import { CustomerTableModel } from 'src/app/models/table-models/customer-table';
import { AuthService } from 'src/app/services/auth.service';
import { CustomerService } from 'src/app/services/customer.service';
import { LoanService } from 'src/app/services/loan.service';
import { PosUserAndSellerListModalService } from './../../../@core/services/pos-user-and-seller-list-modal.service';

@Component({
  selector: 'customer-step',
  templateUrl: './customer-step.component.html',
  styleUrls: ['./customer-step.component.sass']
})
export class CustomerStepComponent implements OnInit {

  @Input() formCustomer: FormGroup = new FormGroup({
    customerFullName: new FormControl(''),
    customerCode: new FormControl(''),
    sellerCode: new FormControl(''),
    sellerName: new FormControl(''),
    rtnFiscalId: new FormControl(''),
    contractNumber: new FormControl(''),
  });

  @Input('customer') set changeCustomer(customer: CustomerTableModel) {
    this.customer = customer;

    if (this.customer.code !== '') {
      this.isModified = true;
      this.selectCustomer(this.customer);
    }

  }
  customer: CustomerTableModel = new CustomerTableModel();

  @Input()
  employee: CustomerTableModel = new CustomerTableModel();

  isModified: boolean = false;
  @Output()
  getCustomerStepInfo = new EventEmitter<any>();

  @Input()
  isForRecollection: boolean = false;
  @Input()
  allowModify: boolean = true;

  @Input()
  onlyCustomer: boolean = false;

  @Input()
  showVerifyAlert: boolean = true;

  constructor(
    private rtnFiscalIdService: PosUpdateRtnFiscalIdModalService,
    private createCustomerModalService: PosCreateCustomerModalService,
    private authService: AuthService,
    private userAndSellerListModalService: PosUserAndSellerListModalService,
    private confirmService: PosConfirmationService,
    private loanService: LoanService,
    private customerService: CustomerService,
    private toastrService: ToastrService,) {
    this.formCustomer.get("rtnFiscalId")?.markAsDirty();
    this.formCustomer.get("rtnFiscalId")?.markAsTouched();

  }

  ngOnInit(): void {
    this.formCustomer.get("customerFullName")?.disable();
    this.formCustomer.get("customerCode")?.disable();
    this.formCustomer.get("sellerCode")?.disable();
    this.formCustomer.get("sellerName")?.disable();
    this.formCustomer.get("rtnFiscalId")?.disable();

  }

  async selectCustomer(customer: CustomerTableModel, employee?: CustomerTableModel, loan?: Loan): Promise<void> {

    if (!this.allowModify && !this.isModified) {
      this.toastrService.info("No se permite cambiar el cliente en una orden");
      return;
    }

    this.customer = customer;
    this.employee = employee != undefined ? employee : this.employee;
    this.formCustomer.get("customerFullName")?.setValue(`[${customer.code}] - ${customer.fullName}`);
    this.formCustomer.get("customerFullName")?.markAsDirty();

    if (!this.onlyCustomer) {
      if (!this.isModified && !this.isForRecollection) {
        const wantsToUseRTN = await this.confirmService.showAsync(`¡Atencion!`, `¿Desea utilizar RTN para esta orden?`, ModalDialogType.WARNING);
        if (wantsToUseRTN) {
          const resultRtnDialog = await this.rtnFiscalIdService.showAsync(customer);
          this.customer = resultRtnDialog.customer;

          if (resultRtnDialog.userAction == 'yes') {
            this.setRtnFiscalId(this.customer);
          } else {
            this.setFistalId(this.customer)
          }

        } else {
          this.setFistalId(this.customer);
        }
      }

      if (!this.isForRecollection) {
        await this.selectEmployee();
      }
    }



    this.getCustomerStepInfo.emit({ customer: this.customer, employee: this.employee, loan: loan });
  }


  async selectEmployee(): Promise<void> {
    if (!this.allowModify && !this.isModified) {
      this.toastrService.info("No se permite cambiar el vendedor en una orden");
      return;
    }

    if (!this.isModified && this.employee.code.trim().length == 0) {
      const seller = (await this.userAndSellerListModalService.show(UserAndSellerShowMode.SELLERS, false)) as CustomerTableModel;
      this.employee.fullName = seller.fullName;
      this.employee.code = seller.code;
    }
    this.isModified = false;
    this.formCustomer.get("sellerName")?.setValue(`[${this.employee.code}] - ${this.employee.fullName}`);
    this.formCustomer.get("sellerName")?.markAsDirty();
    //this.getCustomerStepInfo.emit({ customer: this.customer, employee: this.employee })
  }

  disableRtnButton() {
    return this.formCustomer.get("customerFullName")?.pristine || this.customer.personality == Personality.LEGAL_ENTITY;
  }

  async updateRtnFiscalId() {
    await this.rtnFiscalIdService.show(this.customer, (customer: CustomerTableModel) => {
      this.setRtnFiscalId(customer);

    })
  }

  private setRtnFiscalId(customer: CustomerTableModel) {
    this.customer.useFiscalId2 = true;
    this.formCustomer.get("rtnFiscalId")?.setValue(customer.fiscalId2);
  }

  private setFistalId(customer: CustomerTableModel) {
    this.customer.useFiscalId2 = false;
    this.formCustomer.get("rtnFiscalId")?.setValue(customer.fiscalId);
  }

  async createCustomer() {
    await this.createCustomerModalService.show((customer: CustomerTableModel) => {
      this.selectCustomer(customer);
    });
  }

  async handleSearchByContractNumber(event: any) {
    const contractNumber = this.formCustomer.get('contractNumber')?.value;
    if (contractNumber) {
      const loanResponse = await this.loanService.getCustomerLoans({ page: 0, pageSize: 100, value: { contractNumber } }).toPromise();
      console.log(loanResponse);
      if (loanResponse.response.content.length > 0) {
        const loan = loanResponse.response.content[0];
        const customer = (await this.customerService.readCustomerByCode(loan.customerCode).toPromise());
        this.selectCustomer({ code: customer.code, codeAndFullName: '', customerType: customer.customerType, fiscalId: customer.mainPersonalInfo.fiscalId, fiscalIdType: customer.mainPersonalInfo.fiscalIdType, fiscalId2: customer.mainPersonalInfo.fiscalId2, fullName: customer.fullName, personality: customer.mainPersonalInfo.personality, useFiscalId2: false, age: customer.mainPersonalInfo.age }, undefined, loan);
      }
    }

  }

  get showCreateCustomer() {
    return this.authService.readAccessInStorage().has("PosCustomerCreateComponent_create");
  }
}
